module.exports = __webpack_public_path__ + "03c271081608ebc85717d58003933578.MP3";